import { render, staticRenderFns } from "./NuevaActaReunionPqr.vue?vue&type=template&id=4f6dafa3&scoped=true"
import script from "./NuevaActaReunionPqr.vue?vue&type=script&lang=js"
export * from "./NuevaActaReunionPqr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6dafa3",
  null
  
)

export default component.exports